// extracted by mini-css-extract-plugin
module.exports = {"section":"A_section__3wVZB"};